module.exports = "<script type=\"text/html\" id=\"propertyeditor-switch\">\n  <div class=\"sjs-cb-wrapper\">\n    <label class=\"sjs-cb-switch\">\n        <div class=\"sjs-cb-switch__container\">\n          <input type=\"checkbox\" data-bind=\"checked: koValue, disable: $data.readOnly\"/>\n          <div class=\"sjs-cb-switch_control\">\n            <div class=\"sjs-cb-switch__button\"></div>\n          </div>\n        </div>\n        <span class=\"sjs-cb-switch__label\" data-bind=\"text: $data.displayName\"></span>\n    </label>\n    </div>\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/templates/propertyEditors/propertyeditor-switch.html
// module id = 130
// module chunks = 0